import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClearIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 21,
	viewBox: "0 0 20 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10 0.732544C4.47 0.732544 0 5.20254 0 10.7325C0 16.2625 4.47 20.7325 10 20.7325C15.53 20.7325 20 16.2625 20 10.7325C20 5.20254 15.53 0.732544 10 0.732544ZM15 14.3225L13.59 15.7325L10 12.1425L6.41 15.7325L5 14.3225L8.59 10.7325L5 7.14254L6.41 5.73254L10 9.32254L13.59 5.73254L15 7.14254L11.41 10.7325L15 14.3225Z",
		fill: "#3F5059"
	})
});
export default SvgClearIcon;
